import axios from "axios";
import { BASE_URL } from "../axios_Instanse";
import { setLoading } from "../General/generalActionCreators";
import Store from "../Store";
import { authUnauthorizedMessage, setCaptchaCode } from "./LoginActionCreators";

export const authLessAxios = axios.create({
  baseURL: BASE_URL(),
});

authLessAxios.interceptors.request.use((config) => {
  if (!navigator.onLine) {
    const chanel = new BroadcastChannel("isOnline");
    chanel.postMessage({ msg: "notOnline" });
  }
  config.baseURL = BASE_URL();
  //  config.baseURL = localStorage.MULTI_SERVER_URL;
  Store.dispatch(setLoading(true));

  return config;
});

authLessAxios.interceptors.response.use(
  (config) => {
    Store.dispatch(setLoading(false));
    return config;
  },
  (error) => {
    Store.dispatch(setLoading(false));
    switch (error.response.status) {
      case 400 || 401 || 402 || 403 || 404:
        Store.dispatch(authUnauthorizedMessage(error.response.data));
        // Store.dispatch(setResetCaptcha(resetCaptcha + 1));
        Store.dispatch(setCaptchaCode(""));
        break;

      default:
        break;
    }

    return Promise.reject(error);
  }
);
